export class QuantiteDossierPortefeuilleDTO
{
    nombreTacheEnCours:number;
    montantTacheEnCours:number;

    nombreDossierAcorrige:number;
    montantDossierAcorrige:number;

    nombreDossierValide:number;

    nombreDossierEnRetard:number;
    montantDossierEnRetard:number;

    nombreTacheEnCoursARegulariser:number;
    nombreTacheEncoursNormal:number;

    nombreDossierMiseEnPlace:number;
    montantDossierMiseEnPlace:number;

    nombreDossierAttenteMiseEnPlace:number;
    montantDossierAttenteMiseEnPlace:number;
}